module.exports = fox._r("images/slides/urban/slide_3_1.jpg", __webpack_public_path__ + "images/slides/urban/slide_3_1.jpg");


//////////////////
// WEBPACK FOOTER
// ./images/slides/urban/slide_3_1.jpg
// module id = 60
// module chunks = 2